// ── Aura anonymous identity ────────────────────────────────────────────────────
// Generates and persists a stable anonymous ID in localStorage.
// Survives: tab closes, browser restarts, Aura open/close cycles.
// Does NOT survive: clearing browser data, private browsing mode.
//
// This ID keys the aura_user_profiles table so Aura can recall preferences
// across sessions without requiring account creation.
// ─────────────────────────────────────────────────────────────────────────────

const STORAGE_KEY = 'lwd_anon_id';

function generateId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for environments without crypto.randomUUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

let _cached: string | null = null;

export function getOrCreateAnonId(): string {
  if (_cached) return _cached;

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && stored.length > 8) {
      _cached = stored;
      return stored;
    }
    const newId = generateId();
    localStorage.setItem(STORAGE_KEY, newId);
    _cached = newId;
    return newId;
  } catch {
    // localStorage blocked (private mode, storage quota, etc.)
    // Fall back to a session-scoped ID so Aura still works.
    if (!_cached) _cached = generateId();
    return _cached;
  }
}
